import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useState } from 'react';
const MediaModalContext = createContext({
    isOpen: false,
    MediaModalComponent: undefined,
    toggleModal: () => { }
});
export const MediaModalProvider = ({ MediaModalComponent, children }) => {
    const [open, setOpen] = useState({
        isOpen: false,
        isSelector: false,
        id: 'default'
    });
    const toggleModal = (args) => {
        setOpen({
            isOpen: !open.isOpen,
            isSelector: !!args?.isSelector,
            id: args?.id || 'default',
            defaultSelected: args?.defaultSelected,
            jaenPageId: args?.jaenPageId
        });
    };
    const handleSelect = (mediaNode) => {
        const onSelectEvent = new CustomEvent('mediaNodeSelected', {
            detail: {
                mediaNode,
                uniqueId: open.id
            }
        });
        window.dispatchEvent(onSelectEvent);
    };
    const memoedChildren = React.useMemo(() => children, [children]);
    return (_jsxs(MediaModalContext.Provider, { value: {
            MediaModalComponent,
            isOpen: open.isOpen,
            toggleModal
        }, children: [open.isOpen && (_jsx(React.Suspense, { children: _jsx(MediaModalComponent, { onSelect: handleSelect, isSelector: open.isSelector, defaultSelected: open.defaultSelected, jaenPageId: open.jaenPageId }) })), memoedChildren] }));
};
export const useMediaModal = (args) => {
    const context = useContext(MediaModalContext);
    if (!context) {
        throw new Error('useMediaModal must be used within a MediaModalProvider');
    }
    useEffect(() => {
        if (!args?.onSelect)
            return;
        const onSelectHandler = (event) => {
            if (event.type === 'mediaNodeSelected' &&
                event.detail.uniqueId === `${args.id}-${args.jaenPageId}`) {
                const selectedMediaNode = event.detail.mediaNode;
                args?.onSelect?.(selectedMediaNode);
                context.toggleModal();
            }
        };
        window.addEventListener('mediaNodeSelected', onSelectHandler);
        return () => {
            window.removeEventListener('mediaNodeSelected', onSelectHandler);
        };
    }, [context.toggleModal]);
    if (!context) {
        throw new Error('useMediaModal must be used within a MediaModalProvider');
    }
    return {
        toggleModal: (options) => context.toggleModal({
            id: `${args?.id}-${args?.jaenPageId}`,
            isSelector: !!args?.onSelect,
            defaultSelected: options?.defaultSelected,
            jaenPageId: args?.jaenPageId
        }),
        isOpen: context.isOpen
    };
};
